import { shallow } from 'zustand/shallow'
import { createWithEqualityFn } from 'zustand/traditional'

export interface MainStoreActions {
  setSessionAsExpired: () => void
  setIsAuthenticatedWithDifferentUser: (isAuthenticatedWithDifferentUser: boolean) => void
}

export interface MainStoreState {
  actions: MainStoreActions
  isSessionExpired: boolean
  isAuthenticatedWithDifferentUser: boolean
}

export const useMainStore = createWithEqualityFn<MainStoreState>(
  set => ({
    actions: {
      setSessionAsExpired: () => set(() => ({ isSessionExpired: true })),
      setIsAuthenticatedWithDifferentUser: isAuthenticatedWithDifferentUser =>
        set(() => ({ isAuthenticatedWithDifferentUser })),
    },
    isSessionExpired: false,
    isAuthenticatedWithDifferentUser: false,
  }),
  shallow
)
